import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from '@/hooks/useAuth';
import { ThemeProvider } from '@/hooks/useTheme';
import App from './App';
import '@fontsource-variable/hanken-grotesk';
import '@fontsource-variable/fraunces';
import './index.css';

// Apply the saved theme synchronously before first paint. The app's CSP
// (script-src 'self') blocks an inline <script> in index.html, so we init
// here in the bundled entry instead (a minor flash is acceptable).
(function initTheme() {
  try {
    const saved = localStorage.getItem('theme');
    const dark = saved
      ? saved === 'dark'
      : window.matchMedia('(prefers-color-scheme: dark)').matches;
    document.documentElement.classList.toggle('dark', dark);
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute('content', dark ? '#15140f' : '#faf8f4');
  } catch {
    /* ignore (private mode etc.) */
  }
})();

// React Query client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minuuttia
      gcTime: 1000 * 60 * 30, // 30 minuuttia (entinen cacheTime)
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider>
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <App />
          </AuthProvider>
        </QueryClientProvider>
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>
);
